var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Ellipsis1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 12,
    viewBox: "0 0 46 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_ellipsis_1",
    d: "M8,20a6,6,0,1,0,6,6A6.017,6.017,0,0,0,8,20Zm17,0a6,6,0,1,0,6,6A6.017,6.017,0,0,0,25,20Zm17,0a6,6,0,1,0,6,6A6.017,6.017,0,0,0,42,20ZM8,22a4,4,0,1,1-4,4A3.983,3.983,0,0,1,8,22Zm17,0a4,4,0,1,1-4,4A3.983,3.983,0,0,1,25,22Zm17,0a4,4,0,1,1-4,4A3.983,3.983,0,0,1,42,22Z",
    transform: "translate(-2 -20)",
    fill: "#002b5a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Ellipsis1);
export default __webpack_public_path__ + "static/media/icons8_ellipsis_1.445d62e70b77910e76e62fa6373835a2.svg";
export { ForwardRef as ReactComponent };